import React from 'react'
import { createPortal } from 'react-dom'

interface Props {
    containerElement: Element | null
    children: React.ReactNode
}

const ReactPortal = ({ children, containerElement }: Props) =>
    containerElement ? createPortal(children, containerElement) : null

export default ReactPortal
